import {createAction, props} from '@ngrx/store';
import {FirmaDTO} from '../../openapi/export-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class FirmaEntitiesActions {

  private static readonly prefix = '[Firma Entities]';

  public static getFirma = createAction(
    `${this.prefix} Get Firma`,
    props<{
      firmenId: string,
    }>(),
  );

  public static getFirmaSuccess = createAction(
    `${this.prefix} Get Firma Success`,
    props<{
      firmaDto: FirmaDTO,
    }>(),
  );

  public static getFirmaFailure = createAction(
    `${this.prefix} Get Firma Failure`,
    props<{
      firmenId: string,
      error: MappedHttpErrorResponse,
    }>(),
  );

}
